// extracted by mini-css-extract-plugin
export default {"tag":"TagsViewer_tag__+vazJ","text":"TagsViewer_text__K80UP"};